import { Money } from '@dreryk/money-common-api';

import { StyledFlex, Text, TextView } from '@dreryk/react-components';
import { getCustomFormattingContext, priceFormatter } from '@dreryk/react-common';

import { translationKeys } from '../translations';

import { AdvancePaymentNotification } from './AdvancePaymentNotification';

type AdvancePaymentPaidAmountTextViewProps = Readonly<{ paidAmount: Money; requiredAmount: Money }>;

export const AdvancePaymentPaidAmountTextView = (props: AdvancePaymentPaidAmountTextViewProps): JSX.Element => {
   return (
      <TextView testId={'advancePaymentPaidAmount'} label={translationKeys.advancePaymentPaidAmount}>
         <StyledFlex gap={'8px'}>
            <Text testId={'paidAmount'}>
               {priceFormatter(
                  props.paidAmount.asNumber(),
                  getCustomFormattingContext({
                     options: {
                        currency: 'PLN',
                        stripDecimalZeroes: true,
                     },
                  })
               )}
            </Text>
            <AdvancePaymentNotification paidAmount={props.paidAmount} requiredAmount={props.requiredAmount} />
         </StyledFlex>
      </TextView>
   );
};
